var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageError',{attrs:{"title":_vm.$t('error.403.title'),"subtitle":_vm.$t('error.403.subtitle')}})
}
var staticRenderFns = []

export { render, staticRenderFns }